<template>
  <div>
    <UserProfileUpdate v-if="canUpdate" :user-id="userId" />
  </div>
</template>

<script>
import UserProfileUpdate from "@/views/user/components/UserProfileUpdate";
import { mapGetters } from "vuex";

export default {
  components: {
    UserProfileUpdate,
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters("cognito", { authenticatedUserId: "id" }),
    ...mapGetters("organization", ["organization"]),
    canUpdate() {
      return (this.organization && this.userId === this.organization.id) || this.userId === this.authenticatedUserId;
    },
  },
};
</script>
